<template>
  <div class="editBg">
    <div class="progressBg" v-if="progressFlag">
      <a-progress type="circle" :percent="progressNum" />
    </div>
    <div
      id="editor"
      style="width:100%;
            height:500;background: #ffffff;"
    ></div>
  </div>
</template>
<script>
import E from "wangeditor";
import { mapGetters } from "vuex";
import { message } from "ant-design-vue";
import { getToken } from "@/until/auth";
import { getUserObj } from "@/until/auth";
import { ColSize } from "ant-design-vue/lib/grid/Col";
export default {
  name: "",
  props: {
    tokenStr: {
      type: String,
      default: ""
    },
    attachmentCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      uploadImgUrl:
        process.env.VUE_APP_BASE_API +
        "/assistant/sys/attachment/upload?attachmentCode=" +
        this.attachmentCode +
        "&readType=public", //上传图片api地址
      uploadVideoUrl:
        process.env.VUE_APP_BASE_API +
        "/assistant/sys/attachment/upload?attachmentCode=" +
        this.attachmentCode +
        "&readType=public", //上传视频api地址
      speed: 5, // 设置默认传输速度
      progressNum: 0, //进度条数字
      // 上传视频文件，使用假loading,不能真正的知道上传进度
      transferTime: 0,
      progressFlag: false, //进度条的flag
      editor: null,
      clearIntervalFlag: null
    };
  },

  mounted() {
    this.editor = new E("#editor");
    this.seteditor();
  },
  computed: {
    ...mapGetters({
      userObj: "userObj"
    })
  },
  methods: {
    getHtml() {
      return this.editor.txt.html();
    },
    setHtml(data) {
      this.editor.txt.html(data);
    },
    // 进度条自增
    addProgress() {
      this.clearIntervalFlag = setInterval(() => {
        this.progressNum += Math.floor((99 / (this.transferTime * 100)) * 100);
        if (this.progressNum >= 99) {
          this.progressNum = 99;
          clearInterval(this.clearIntervalFlag);
        }
      }, 100);
    },
    seteditor() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      console.log('wangeditor')
      // this.editor = new E(this.$refs.editor)
      // 选择语言
      this.editor.config.lang = "zh-CN";
      // 引入 i18next 插件
      this.editor.i18next = window.i18next;
      this.editor.config.uploadImgShowBase64 = false; // base 64 存储图片
      this.editor.config.uploadImgServer = this.uploadImgUrl; // 填写配置服务器端地址
      this.editor.config.uploadImgHeaders = { token: getToken() }; // 自定义 header
      this.editor.config.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 6 张图片
      this.editor.config.uploadImgTimeout = 10 * 60 * 1000; // 设置超时时间
      //   this.editor.config.showLinkImg = false //隐藏插入网络图片的功能
      // 自定义 onchange 触发的延迟时间，默认为 200 ms
      this.editor.config.onchangeTimeout = 200; // 单位 ms

      this.editor.config.uploadImgHooks = {
        customInsert: (insertImg, result) => {
          // 循环插入图片
          if (result.code === 0) {
            console.log(new Date().getTime());
            const url = result.data.ossUrl;
            insertImg(url);
          } else {
            //  message.error("图片插入失败，请稍后再试");
            message.error(result.msg);
          }
        }
      };

      // 视频上传
      this.editor.config.showLinkVideo = false; //隐藏插入网络视频的功能
      this.editor.config.uploadVideoServer = this.uploadVideoUrl; // 上传接口
      this.editor.config.uploadVideoHeaders = {
        token: getToken(),
        "Access-Control-Allow-Origin": "*"
      }; // 自定义 header

      this.editor.config.uploadVideoMaxSize = 1 * 1024 * 1024 * 1024; // 1024m
      this.editor.config.uploadVideoName = "file";
      this.editor.config.uploadVideoAccept = ["mp4", "MP4"];
      this.editor.config.uploadVideoHooks = {
        // 上传视频之前
        before: function(xhr, editor, resultFiles) {
          // 根据传输速度查看文件能传输多少秒
          that.transferTime = Math.ceil(
            resultFiles[0].size / (1024 * 1024) / that.speed
          );
          // 判断文件大小，不能超过规定大小
          const fileSize = resultFiles[0].size;
          if (fileSize > that.editor.config.uploadVideoMaxSize) {
            // 可阻止视频上传
            return {
              prevent: true,
              msg: "文件最大支持1G"
            };
          }
          that.progressFlag = true;
          that.progressNum = 0;
          that.addProgress();
        },
        // 上传视频出错，一般为 http 请求的错误
        error: function(xhr, editor, resData) {
          that.progressFlag = false;
        },
        // 视频上传并返回了结果，但视频插入时出错了
        fail: function(xhr, editor, resData) {
          that.progressFlag = false;
        },
        customInsert: function(insertVideo, result) {
          that.progressNum = 100;
          //   上传完成后展示100毫秒在关闭弹窗层
          setTimeout(() => {
            that.progressFlag = false;
          }, 100);

          window.clearInterval(that.clearIntervalFlag);
          if (result.code === 0) {
            console.log(new Date().getTime());
            const link = result.data.ossUrl;
            insertVideo(link);
          } else {
            // message.error("视频上传失败，请稍后再试");
            message.error(result.msg);
          }
        }
      };

      this.editor.config.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
    }
  },
  components: {},
  filters: {},
  beforeUnmount() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy();
    this.editor = null;
  }
};
</script>
<style lang="scss" scoped>
.editBg {
  position: relative;
  .progressBg {
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;
    text-align: center;
    background: rgba(0, 0, 0, 0.1);
    .ant-progress {
      position: absolute;
      width: 120px;
      height: 120px;
      top: calc(50% - 60px);
      left: calc(50% - 60px);
    }
  }
  #editor {
    position: relative;
    z-index: 9;
  }
}
</style>
